import toast from 'cogo-toast'

import { t } from '@lingui/macro'

export const submit = (mutate, id, i18n) => {
  return ({ note }, formikBag) => {
    mutate({
      variables: {
        id,
        note,
      },
    }).then(() => {
      formikBag.setSubmitting(false)
      toast.success(t(i18n)`Appunti salvati`)
    })
  }
}
